/** Reset and Save at the end of a form: both stay disabled until something changed (Save also until valid), and Reset while a save is pending. */

import { Save } from 'lucide-react';

import { ActionButton, type ButtonState } from './ActionButton';

export function SaveBar({
  changed,
  valid = true,
  state,
  onReset,
  onSave,
}: {
  changed: boolean;
  valid?: boolean;
  state: ButtonState;
  onReset: () => void;
  /** Omit when the surrounding form's onSubmit does the saving. */
  onSave?: () => void;
}) {
  return (
    <div className="form-actions">
      <button type="button" className="btn btn-secondary" disabled={!changed || state.pending} onClick={onReset}>
        Reset
      </button>
      <ActionButton
        state={state}
        label="Save"
        icon={<Save aria-hidden="true" />}
        type={onSave ? 'button' : 'submit'}
        disabled={!changed || !valid}
        onClick={onSave}
      />
    </div>
  );
}
